import { render, staticRenderFns } from "./otherChargeItem.vue?vue&type=template&id=03fabae2&"
import script from "./otherChargeItem.vue?vue&type=script&lang=js&"
export * from "./otherChargeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fabae2')) {
      api.createRecord('03fabae2', component.options)
    } else {
      api.reload('03fabae2', component.options)
    }
    module.hot.accept("./otherChargeItem.vue?vue&type=template&id=03fabae2&", function () {
      api.rerender('03fabae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/otherChargeItem.vue"
export default component.exports